import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

@Injectable()
export class DateAdapterService extends NgbDateAdapter<string> {
  fromModel(date: string): NgbDateStruct {
    if (date) {
      var momentDate = moment(date);
      if (momentDate && momentDate.isValid()) {
        return { year: momentDate.year(), month: momentDate.month() + 1, day: momentDate.date() };
      }
    }
    return null;
  }

  toModel(date: NgbDateStruct): string {
    if (date && date.year) {
      var nativeDate = new Date(date.year, date.month - 1, date.day);
      var momentDate = moment(nativeDate);
      return momentDate.format('YYYY-MM-DD');
    }
    return null;
  }
}